<template>
  <div>

    <div class="text-h6 mt-2 mb-4" v-if="list_options.list.length > 0 || list_activites.list.length > 0">Modifier les
      options/activités de {{ inscription.prenom }} {{ inscription.nom }}</div>
    <div v-for="(option, index) in list_options.list" :key="option.id" style="width: 800px"
      class="container_option_item d-flex flex-wrap justify-start align-center gap bordered rounded bg-grey_1 pa-1 mb-2">
      <div class="ml-1" style="margin-right: auto">
        <div class="text-h6">Option: {{ option.nom }} - {{ get_text_prix(option.prix) }}</div>
        <div class="text-body ml-1" v-if="option.information_variante_tarif != ''">{{ option.information_variante_tarif
          }}</div>
        <div class="text-subtitle ml-1" v-if="option.quantite != 0">
          {{ option.quantite - option.nb_inscrits > 0 ? option.quantite - option.nb_inscrits + " places restantes" :
            "Complet" }}
        </div>
      </div>
      <div class="d-flex flex-wrap align-center gap bg-white bordered pa-2 rounded justify-self-end">
        <div class="text-body-1 pt-2">Quantité</div>
        <v-btn @click="minus_quantity_option(index)"><v-icon icon="mdi-minus"></v-icon> </v-btn>
        <div class="text-h6">{{ option.quantite_souhaite }}</div>
        <v-btn @click="plus_quantity_option(index)"><v-icon icon="mdi-plus"></v-icon> </v-btn>
      </div>
    </div>

    <div v-for="(activite, index) in list_activites.list" :key="activite.id" style="width: 800px"
      class="container_option_item d-flex flex-wrap justify-start align-center gap bordered rounded bg-grey_1 pa-1 mb-2">
      <div class="ml-1" style="margin-right: auto">
        <div class="text-h6">Activité: {{ activite.nom }} - {{ get_text_prix(activite.prix) }}</div>
        <div class="text-subtitle" v-if="activite.quantite - activite.nb_inscrits > 0">
          {{ activite.quantite - activite.nb_inscrits + " places restantes" }}
        </div>
        <div class="text-subtitle" v-else>
          Complet
        </div>

      </div>
      <div class="d-flex flex-wrap align-center gap bg-white bordered pa-2 rounded justify-self-end">
        <div class="text-body-1 pt-2">Quantité</div>
        <v-btn @click="minus_quantity_activite(index)"><v-icon icon="mdi-minus"></v-icon> </v-btn>
        <div class="text-h6">{{ activite.quantite_souhaite }}</div>
        <v-btn @click="plus_quantity_activite(index)"><v-icon icon="mdi-plus"></v-icon> </v-btn>
      </div>
    </div>
    <v-row class="d-flex justify-center" v-if="list_options.list.length > 0 || list_activites.list.length > 0">
      <v-col md="4" cols="12">
        <v-btn color="primary-dark" block class="sm-fullwidth mt-2 inscription_btn" variant="tonal"
          @click="saveOptions"> <v-icon icon="mdi-arrow-right-bold"></v-icon> Mettre à jour les options </v-btn>
      </v-col>
    </v-row>
    <v-alert color="dark-red" variant="tonal" class="mb-2" v-for="(error, index_error) in errors" :key="index_error"
      type="error">
      {{ error }}
    </v-alert>
    <v-dialog v-model="display_confirm_dialog_options" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-h6">Modification des options</div>
          <p>Les options de {{ inscription.nom }} {{ inscription.prenom }} ont bien été mise à jour.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary-dark" text @click="display_confirm_dialog_options = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import List_Options from "@/classes/Options/List_Options.class.js";
import List_Activites from "@/classes/Activites/List_Activites.class";
export default {
  name: "EditSelectionOptions",
  props: ["item"],
  data() {
    return {
      inscription: {},
      list_options: {},
      list_activites: {},
      display_confirm_dialog_options: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    saveOptions() {
      let update_options = this.inscription.update_options_coureur_admin(this.mainStore.authAdmin.adminData.username);
      if (update_options) {
        this.display_confirm_dialog_options = true;
      } else {
        this.errors.push("Une erreur est survenue lors de la modification des options. Merci de réessayer ultérieurement.");
      }
    },
    get_text_prix(prix) {
      if (prix == 0) {
        return "Gratuit";
      } else {
        return prix + "€";
      }
    },
    minus_quantity_option(index) {
      if (this.list_options.list[index].quantite_souhaite > 0) {
        this.list_options.list[index].quantite_souhaite--;
        this.$emit("updateQuantiteOption", this.list_options.list);
      }
    },
    plus_quantity_option(index) {
      if (this.list_options.list[index].quantite_souhaite < 10) {
        this.list_options.list[index].quantite_souhaite++;
        this.$emit("updateQuantiteOption", this.list_options.list);
      }
    },
    minus_quantity_activite(index) {
      if (this.list_activites.list[index].quantite_souhaite > 0) {
        this.list_activites.list[index].quantite_souhaite--;
        this.$emit("updateQuantiteActivite", this.list_activites.list);
      }
    },
    plus_quantity_activite(index) {
      if (this.list_activites.list[index].quantite_souhaite < 10) {
        this.list_activites.list[index].quantite_souhaite++;
        this.$emit("updateQuantiteActivite", this.list_activites.list);
      }
    },

    init_options_from_inscription() {
      this.list_options.list.forEach((option) => {
        this.inscription.commande_options.forEach((commande_option) => {
          if (commande_option.id_item == option.id && commande_option.type == "option") {
            option.quantite_souhaite = commande_option.quantite;
          }
        });
      });
    },
    init_activites_from_inscription() {
      this.list_activites.list.forEach((activite) => {
        this.inscription.commande_options.forEach((commande_activite) => {
          if (commande_activite.id_item == activite.id && commande_activite.type == "activite") {
            activite.quantite_souhaite = commande_activite.quantite;
          }
        });
      });
    },
  },
  async created() {
    this.inscription = this.item;
    this.list_options = new List_Options(this.mainStore.module.id);
    this.list_options.initialize_from_mainstore(this.mainStore.module.options.list);
    this.list_activites = new List_Activites(this.mainStore.module.id);
    this.list_activites.initialize_from_mainstore(this.mainStore.module.activites.list);
    this.init_options_from_inscription();
    this.init_activites_from_inscription();
  },
};
</script>

<style lang="scss" scoped></style>